import { render, staticRenderFns } from "./AwardImg.vue?vue&type=template&id=3afc3fb2&scoped=true"
import script from "./AwardImg.vue?vue&type=script&lang=js"
export * from "./AwardImg.vue?vue&type=script&lang=js"
import style0 from "./AwardImg.vue?vue&type=style&index=0&id=3afc3fb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3afc3fb2",
  null
  
)

export default component.exports